// extracted by mini-css-extract-plugin
module.exports = {"card":"OnboardingTeacherModal_card__DPgtT"};